var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSuccessChip = function SvgSuccessChip(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8889 97.7778C75.8895 97.7778 97.7778 75.8895 97.7778 48.8889C97.7778 21.8883 75.8895 0 48.8889 0C21.8883 0 0 21.8883 0 48.8889C0 75.8895 21.8883 97.7778 48.8889 97.7778Z",
    fill: "#74B711"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1693 30.5488C75.0122 29.3232 73.1363 29.3232 71.979 30.5488L36.4809 68.145L22.836 53.6937C21.6789 52.4682 19.803 52.4683 18.6457 53.6937C17.4885 54.9192 17.4885 56.906 18.6457 58.1315L34.3857 74.8014C35.5425 76.0268 37.4198 76.026 38.576 74.8014L76.1693 34.9867C77.3264 33.7613 77.3263 31.7744 76.1693 30.5488Z",
    fill: "#F3F3F3"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSuccessChip, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/successChip.c6e17dc5.svg";
export { ForwardRef as ReactComponent };